export const initialState: SidebarState = {
	open: false,
};
